// project imports
import * as actionTypes from "./actions";

export const initialState = {
  submitStatus: false,
  items: [],
};

const returnItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_ITEMS:
      return {
        ...state,
        items: [...state.items, { id: action.id, features: action.features }],
      };
    case actionTypes.CLEAR_ITEMS:
      return {
        ...state,
        items: [],
      };
    case actionTypes.SET_SUBMIT_STATUS:
      return {
        ...state,
        submitStatus: action.value,
      };
    default:
      return state;
  }
};

export default returnItemsReducer;
